import { render, staticRenderFns } from "./SearchPassangers.vue?vue&type=template&id=1f2fcb92&scoped=true"
import script from "./SearchPassangers.vue?vue&type=script&lang=js"
export * from "./SearchPassangers.vue?vue&type=script&lang=js"
import style0 from "./SearchPassangers.vue?vue&type=style&index=0&id=1f2fcb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fcb92",
  null
  
)

export default component.exports